import { useQuery } from '../use-query';
import { inventoryService } from '../../../services';
import { extendContainerValidator } from '../../../utils';

export const useInventoryQuery = (keys: any = {}) => {
  return useQuery(
    ['inventorys', JSON.stringify(keys)],
    () => {
      const params = { ...keys };

      delete params.yardName;

      return inventoryService
        .getAll({
          params,
        })
        .then((res) => res.data);
    },
    { initialData: { data: [], totalCount: 0 }, keepPreviousData: true },
  );
};

export const useInventoryOneQuery = ({ id, ...keys }: any = {}) => {
  if (keys.number?.length < 3 || !extendContainerValidator(keys.number)) delete keys.number;
  if (keys.status === 'DISMATCHED') delete keys.status;

  return useQuery(
    ['inventory', id, JSON.stringify(keys)],
    () => {
      return inventoryService
        .getOne({
          params: keys,
          id,
        })
        .then((res) => res.data);
    },
    {
      keepPreviousData: true,
    },
  );
};
